module.exports = __webpack_public_path__ + "static/exhibit-overall.86c3bb2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exhibit-overall.png
// module id = 1387
// module chunks = 252003105885195